module.exports = __webpack_public_path__ + "a53bee5a7be93a110ce7404f2523efeb.svg";